




















import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import request, { Response } from '@/helpers/requests'
import { PhoneNumber } from '@/pages/PhoneNumberManagement/types/phone-number'


interface LoadResponseData extends Response {
    data: PhoneNumber[];
}


@Component({
    components: {}
})
export default class AvailableNumberTable extends Vue {
    loading = false
    @Prop() value: PhoneNumber|null = null
    @Prop() locationValid = false
    phoneNumbers: PhoneNumber[] = []
    headers = [
        { text: 'Phone Number', value: 'phoneNumber', align: 'left' },
        { text: 'Type', value: 'type', align: 'left' },
        { text: 'Vanity', value: 'vanity' },
        { text: 'Status', value: 'status' }
    ]

    @Watch('locationValid')
    locationValidityUpdated(newVal: boolean) {
        this.locationValid = newVal
        if (this.locationValid) {
            this.load()
        }
    }

    async load() {
        this.loading = true
        const resp = await request.post('/support/available-number-list', {}) as LoadResponseData
        this.phoneNumbers = resp.data
        this.loading = false
        return resp
    }

    @Emit('input')
    handleInput(item: { item: PhoneNumber; value: boolean }): PhoneNumber|null {
        return item.value ? item.item : null
    }
}
